import { ArrowRight } from "lucide-react";
import { EMAIL, IMAGES } from "../../data/content";

export const Govxi = () => (
  <section id="intelligence" className="bg-[#0A0A0A] border-y border-white/10" data-testid="govxi-section">
    <div className="grid lg:grid-cols-2">
      <div className="px-6 lg:px-12 py-24 lg:py-32 flex flex-col justify-center">
        <p className="font-mono text-xs tracking-[0.35em] text-white/50 flex items-center gap-4">
          GOVXI <span className="inline-block w-16 h-px bg-white/20" />
        </p>
        <h2 className="mt-8 font-display text-4xl sm:text-5xl leading-[1.1] tracking-tight text-white" data-testid="govxi-headline">
          From Systems of Record to Systems of Intelligence.
        </h2>
        <p className="mt-8 text-base leading-relaxed text-white/60">
          GOVXI is A-Square Group's strategic initiative to advance governance
          through intelligence — combining data, technology and institutional
          insight to help governments anticipate, decide and deliver.
        </p>
        <p className="mt-4 text-sm leading-relaxed text-white/40">
          Built on sovereign digital infrastructure, GOVXI enables governments to
          simulate policy outcomes, optimize public resources and anticipate
          systemic risks across public health, the economy, infrastructure and
          cybersecurity.
        </p>
        <a
          href={`mailto:${EMAIL}?subject=GOVXI%20Enquiry`}
          data-testid="govxi-explore-btn"
          className="mt-10 inline-flex items-center gap-3 font-mono text-xs tracking-[0.3em] text-white border-b border-white/40 pb-3 w-fit hover:border-white hover:gap-5 transition-all duration-300"
        >
          EXPLORE GOVXI <ArrowRight className="w-4 h-4" />
        </a>
      </div>
      <div className="relative overflow-hidden min-h-[320px] lg:min-h-0 border-t lg:border-t-0 lg:border-l border-white/10">
        <img
          src={IMAGES.commandCenter}
          alt="Government intelligence command center"
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#0A0A0A]/30" />
      </div>
    </div>
  </section>
);
